import { Box, Typography } from "@mui/material";
import React from "react";

// "Triggered By <Agent>: <reason>" row for dual-agent cards, where one agent
// sensed the situation and another one acts on it (Iris → Dave deal,
// Ross → Iris price revert).
const TriggeredByAgent = ({ agent, reason }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1.125,
      mb: 1.5,
      pb: 1.5,
      borderBottom: "1px solid #f1f2f6",
    }}
  >
    <Box
      component="img"
      src={agent.avatar}
      alt={agent.name}
      sx={{
        width: 30,
        height: 30,
        borderRadius: "50%",
        border: `2px solid ${agent.color}`,
        backgroundColor: "#fff",
      }}
    />
    <Typography variant="body2" sx={{ color: "#6b7280" }}>
      Triggered By{" "}
      <span style={{ color: agent.color, fontWeight: 700 }}>{agent.name}</span>
      {reason ? `: ${reason}` : ""}
    </Typography>
  </Box>
);

export default TriggeredByAgent;
